<template>
  <div class="wrapper">
    <div class="card groupcard mt-4 mb-4 card-layout">
      <b-row class="generalRow">
        <b-col class="border-right-color col-12 col-md-6">
          <div class="generalScroll">
            <b-row>
              <b-col class="border-bottom-color font-bold">Organisation Details</b-col>
            </b-row>
            <b-row>
              <b-col>Name of the Organisation</b-col>
              <b-col class="answer">{{organisationName}}</b-col>
            </b-row>
            <b-row>
              <b-col>Associated with L&T as a</b-col>
              <b-col class="answer">{{associateWithLnTAsA}}</b-col>
            </b-row>
            <b-row>
              <b-col>Country</b-col>
              <b-col class="answer">{{partnerdetail.country}}</b-col>
            </b-row>
            <b-row>
              <b-col>{{partnerdetail.idCardName}}</b-col>
              <b-col class="answer">{{pan}}</b-col>
            </b-row>
            <b-row>
              <b-col class="inner-title">Contact Details</b-col>
            </b-row>
            <b-row>
              <b-col>Coordinate Person</b-col>
              <b-col class="answer">{{coOrdinatePerson}}</b-col>
            </b-row>
            <b-row>
              <b-col>Designation</b-col>
              <b-col class="answer">{{designation}}</b-col>
            </b-row>
            <b-row>
              <b-col>Mobile Number</b-col>
              <b-col class="answer">+{{partnerdetail.isdCode}}-{{mobileNumber}}</b-col>
            </b-row>
            <b-row>
              <b-col>Email</b-col>
              <b-col class="answer">{{email}}</b-col>
            </b-row>
            <b-row v-if="!branchLogIn">
              <b-col class="inner-title">Registered Office Address</b-col>
            </b-row>
            <b-row v-if="!branchLogIn">
              <b-col>Street Address</b-col>
              <b-col class="answer">{{regStreetAddress}}</b-col>
            </b-row>
            <b-row v-if="!branchLogIn">
              <b-col>Country</b-col>
              <b-col class="answer">{{regCountry}}</b-col>
            </b-row>
            <b-row v-if="!branchLogIn">
              <b-col>State</b-col>
              <b-col class="answer">{{regState}}</b-col>
            </b-row>
            <b-row v-if="!branchLogIn">
              <b-col>City</b-col>
              <b-col class="answer">{{regCity}}</b-col>
            </b-row>
            <b-row v-if="!branchLogIn">
              <b-col>Zip Code</b-col>
              <b-col class="answer">{{regZipCode}}</b-col>
            </b-row>
            <b-row>
              <b-col class="inner-title">Correspondence Address</b-col>
            </b-row>
            <b-row>
              <b-col>Street Address</b-col>
              <b-col class="answer">{{streetAddress}}</b-col>
            </b-row>
            <b-row>
              <b-col>Country</b-col>
              <b-col class="answer">{{country}}</b-col>
            </b-row>
            <b-row>
              <b-col>State</b-col>
              <b-col class="answer">{{state}}</b-col>
            </b-row>
            <b-row>
              <b-col>City</b-col>
              <b-col class="answer">{{city}}</b-col>
            </b-row>
            <b-row>
              <b-col>Zip Code</b-col>
              <b-col class="answer">{{zipCode}}</b-col>
            </b-row>
            <b-row>
              <b-col class="inner-title">Statutory Information</b-col>
              <b-col></b-col>
            </b-row>
            <b-row v-if="!branchLogIn && partnerdetail.country.toLowerCase() == 'india'">
              <b-col>Incorporated as</b-col>
              <b-col class="answer">{{incorporatedAs}}</b-col>
            </b-row>
            <b-row>
              <b-col>Year of Incorporation</b-col>
              <b-col class="answer">{{yearOfIncorporation}}</b-col>
            </b-row>
            <b-row v-if="!branchLogIn && partnerdetail.country.toLowerCase() == 'india'">
              <b-col>Place of Incorporation</b-col>
              <b-col class="answer">{{placeOfIncorporation}}</b-col>
            </b-row>
            <b-row v-if="msmeNumber && partnerdetail.country.toLowerCase() == 'india'">
              <b-col>MSME Number</b-col>
              <b-col class="answer">{{msmeNumber}}</b-col>
            </b-row>
            <b-row v-if="msmeNumber && partnerdetail.country.toLowerCase() == 'india'">
              <b-col>MSME Type</b-col>
              <b-col class="answer">{{msmeType}}</b-col>
            </b-row>
            <b-row v-if="msmeNumber && partnerdetail.country.toLowerCase() == 'india'">
              <b-col>MSME Sector</b-col>
              <b-col class="answer">{{statutoryDetails.sector}}</b-col>
            </b-row>
            <b-row v-if="msmeNumber && partnerdetail.country.toLowerCase() == 'india'">
              <b-col>MSME investedAmount</b-col>
              <b-col class="answer">{{statutoryDetails.investedAmount}}</b-col>
            </b-row>
            <b-row v-if="msmeNumber && partnerdetail.country.toLowerCase() == 'india'">
              <b-col>MSME EffectivePeriod</b-col>
              <b-col
                class="answer"
              >{{statutoryDetails.effectiveFrom}} to {{statutoryDetails.effectiveUpto}}</b-col>
            </b-row>

            <b-row v-if="cinNumber">
              <b-col v-if="partnerdetail.country.toLowerCase() == 'india'">CIN Number</b-col>
              <b-col v-if="partnerdetail.country.toLowerCase() != 'india'">CRN/ CLN</b-col>
              <b-col class="answer">{{cinNumber}}</b-col>
            </b-row>
            <b-row v-if="llpinNumber">
              <b-col>LLPIN Number</b-col>
              <b-col class="answer">{{llpinNumber}}</b-col>
            </b-row>
            <b-row v-if="frnNumber">
              <b-col>Firm Registration Number</b-col>
              <b-col class="answer">{{frnNumber}}</b-col>
            </b-row>
            <b-row v-if="sernNumber">
              <b-col>Shop Est & Reg Number</b-col>
              <b-col class="answer">{{sernNumber}}</b-col>
            </b-row>
            <b-row v-if="isMsme && partnerdetail.country.toLowerCase() == 'india'">
              <b-col>Is MSME</b-col>
              <b-col class="answer">{{isMsme == 'Y' ? 'Yes' : 'No'}}</b-col>
            </b-row>
            <b-row v-if="gstNumber && partnerdetail.country.toLowerCase() == 'india'">
              <b-col>GST Number</b-col>
              <b-col class="answer">{{gstNumber}}</b-col>
            </b-row>
            <b-row v-if="gstDocument && partnerdetail.country.toLowerCase() == 'india'">
              <b-col>GST Document</b-col>
              <b-col class="answer">
                <a href="#" @click="showAttachFile(gstDocument)">{{document(gstDocument)}}</a>
              </b-col>
            </b-row>
            <b-row v-if="tanNumber && partnerdetail.country.toLowerCase() == 'india'">
              <b-col>TAN Number</b-col>
              <b-col class="answer">{{tanNumber}}</b-col>
            </b-row>
            <b-row v-if="tanDocument && partnerdetail.country.toLowerCase() == 'india'">
              <b-col>TAN Document</b-col>
              <b-col class="answer">
                <a href="#" @click="showAttachFile(tanDocument)">{{document(tanDocument)}}</a>
              </b-col>
            </b-row>
            <b-row v-if="vatNumber && partnerdetail.country.toLowerCase() != 'india'">
              <b-col>VAT Number</b-col>
              <b-col class="answer">{{vatNumber}}</b-col>
            </b-row>
            <b-row v-if="vatDocument && partnerdetail.country.toLowerCase() != 'india'">
              <b-col>VAT Document</b-col>
              <b-col class="answer">
                <a href="#" @click="showAttachFile(vatDocument)">{{document(vatDocument)}}</a>
              </b-col>
            </b-row>
            <b-row v-if="aadhaarNumber && partnerdetail.country.toLowerCase() == 'india'">
              <b-col>Aadhaar Number</b-col>
              <b-col class="answer">{{aadhaarNumber}}</b-col>
            </b-row>
            <b-row v-if="aadhaarDocument && partnerdetail.country.toLowerCase() == 'india'">
              <b-col>Aadhaar Document</b-col>
              <b-col class="answer">
                <a href="#" @click="showAttachFile(aadhaarDocument)">{{document(aadhaarDocument)}}</a>
              </b-col>
            </b-row>
            <b-row v-if="isEinvoiceApplicable && partnerdetail.country.toLowerCase() == 'india'">
              <b-col>Is E-Invoice Applicable</b-col>
              <b-col class="answer">{{isEinvoiceApplicable == 'Y' ? 'Yes' : 'No'}}</b-col>
            </b-row>
            <b-row v-if="isTCSApplicable && partnerdetail.country.toLowerCase() == 'india'">
              <b-col>Is TCS Applicable</b-col>
              <b-col class="answer">{{isTCSApplicable == 'Y' ? 'Yes' : 'No'}}</b-col>
            </b-row>
            <span v-if="pfRegistrationId && partnerdetail.country.toLowerCase() == 'india'">
              <b-row>
                <b-col>PF Registration ID</b-col>
                <b-col class="answer">{{pfRegistrationId}}</b-col>
              </b-row>
              <b-row>
                <b-col>PF Regional Office</b-col>
                <b-col class="answer">{{pfRegionalOffice}}</b-col>
              </b-row>
            </span>
            <span v-if="pfCount && partnerdetail.country.toLowerCase() == 'india'">
              <b-row>
                <b-col>PF Employee Count</b-col>
                <b-col class="answer">{{pfCount}}</b-col>
              </b-row>
            </span>
            <span v-if="esiRegistrationId && partnerdetail.country.toLowerCase() == 'india'">
              <b-row>
                <b-col>ESI Registration ID</b-col>
                <b-col class="answer">{{esiRegistrationId}}</b-col>
              </b-row>
              <b-row>
                <b-col>ESI Regional Office</b-col>
                <b-col class="answer">{{esiRegionalOffice}}</b-col>
              </b-row>
            </span>
            <span v-if="esiRemarks && partnerdetail.country.toLowerCase() == 'india'">
              <b-row>
                <b-col>ESI Remarks</b-col>
                <b-col class="answer">{{esiRemarks}}</b-col>
              </b-row>
            </span>
          </div>
          <b-row v-if="factoryDetails.length > 0 ">
            <b-col class="factory-border-bottom-color font-bold">Factory Details</b-col>
          </b-row>
          <div class="factoryScroll" v-if="factoryDetails.length > 0 ">
            <span v-for="(factory,i) in factoryDetails" :key="i">
              <b-row>
                <b-col>
                  <b-row>
                    <b-col class="inner-title">Factory Details-{{i+1}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Name</b-col>
                    <b-col class="answer">{{factory.factoryName}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Street Address</b-col>
                    <b-col class="answer">{{factory.streetAddress}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>State</b-col>
                    <b-col class="answer">{{factory.stateCode}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>City</b-col>
                    <b-col class="answer">{{factory.cityCode}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Zip Code</b-col>
                    <b-col class="answer">{{factory.postalCode}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Factory Certificate Number</b-col>
                    <b-col class="answer">{{factory.inspectionCfNo}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Shop Establishment Certificate Number</b-col>
                    <b-col class="answer">{{factory.establishmentCfNo}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Year of Manufacturing</b-col>
                    <b-col class="answer">{{factory.yearCommencementMfg}}</b-col>
                  </b-row>
                  <span v-for="(ware,i) in factory.warehouseDetail" :key="i">
                    <b-row>
                      <b-col class="inner-title">Factory attached warehouse-{{i+1}}</b-col>
                    </b-row>
                    <b-row>
                      <b-col>Name</b-col>
                      <b-col class="answer">{{ware.warehouseName}}</b-col>
                    </b-row>
                    <b-row>
                      <b-col>Street Address</b-col>
                      <b-col class="answer">{{ware.streetAddress}}</b-col>
                    </b-row>
                    <b-row>
                      <b-col>State</b-col>
                      <b-col class="answer">{{ware.stateCode}}</b-col>
                    </b-row>
                    <b-row>
                      <b-col>City</b-col>
                      <b-col class="answer">{{ware.cityCode}}</b-col>
                    </b-row>
                    <b-row>
                      <b-col>Zip Code</b-col>
                      <b-col class="answer">{{ware.postalCode}}</b-col>
                    </b-row>
                    <b-row>
                      <b-col>Stock Value</b-col>
                      <b-col class="answer">{{ware.stockValue}}</b-col>
                    </b-row>
                    <b-row>
                      <b-col>Total Area</b-col>
                      <b-col class="answer">{{ware.totalArea}}</b-col>
                    </b-row>
                  </span>
                </b-col>
              </b-row>
            </span>
          </div>
          <b-row class="mt-2" v-if="wareHouseDetail.length > 0">
            <b-col class="factory-border-bottom-color font-bold mt-2">WareHouse Details</b-col>
          </b-row>
          <div class="contactScroll" v-if="wareHouseDetail.length > 0">
            <span v-for="(warehouse,i) in wareHouseDetail" :key="i">
              <b-row>
                <b-col>
                  <b-row>
                    <b-col class="inner-title">warehouse Details-{{i+1}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Name</b-col>
                    <b-col class="answer">{{warehouse.warehouseName}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Street Address</b-col>
                    <b-col class="answer">{{warehouse.streetAddress}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>State</b-col>
                    <b-col class="answer">{{warehouse.stateCode}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>City</b-col>
                    <b-col class="answer">{{warehouse.cityCode}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Zip Code</b-col>
                    <b-col class="answer">{{warehouse.postalCode}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Stock Value</b-col>
                    <b-col class="answer">{{warehouse.stockValue}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Total Area</b-col>
                    <b-col class="answer">{{warehouse.totalArea}}</b-col>
                  </b-row>
                </b-col>
              </b-row>
            </span>
          </div>
          <b-row>
            <b-col class="border-bottom-color font-bold mt-2">Contact Details</b-col>
          </b-row>
          <div class="contactScroll">
            <span v-for="(contact,i) in contactDetails" :key="i">
              <b-row>
                <b-col>
                  <b-row>
                    <b-col
                      class="inner-title"
                      v-if="contact.contactCategory == 'P'"
                    >Prmary Contact - {{i+1}}</b-col>
                    <b-col
                      class="inner-title"
                      v-if="contact.contactCategory == 'S'"
                    >Secondary Contact - {{i+1}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Name</b-col>
                    <b-col class="answer">{{contact.name}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Designation</b-col>
                    <b-col class="answer">{{contact.designation}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Department</b-col>
                    <b-col class="answer">{{contact.department}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Mobile Number</b-col>
                    <b-col class="answer">+{{partnerdetail.isdCode}}-{{contact.mobileNUmber}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Email-Id</b-col>
                    <b-col class="answer">{{contact.email}}</b-col>
                  </b-row>
                </b-col>
              </b-row>
            </span>
          </div>
          <b-row v-if="factoryDetails.length == 0">
            <b-col class="border-bottom-color font-bold">Bank Details</b-col>
          </b-row>
          <div class="bankScroll" v-if="factoryDetails.length == 0">
            <span v-for="(account,i) in bankAccounts" :key="i">
              <b-row>
                <b-col>
                  <b-row>
                    <b-col class="inner-title">Bank Account Details-{{i+1}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Account type</b-col>
                    <b-col class="answer">{{account.accountType}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Account Number</b-col>
                    <b-col class="answer">{{account.accountNumber}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Payment in favour of</b-col>
                    <b-col class="answer">{{account.accountHolderName}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Payment Mode</b-col>
                    <b-col class="answer">{{account.paymentMode}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Bank Name</b-col>
                    <b-col class="answer">{{account.bankName}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>IFSC Code</b-col>
                    <b-col class="answer">{{account.ifscCodeOrMicr}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Swift Code</b-col>
                    <b-col class="answer">{{account.swiftBicCode}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>IBAN Number</b-col>
                    <b-col class="answer">{{account.ibanNumber}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Sort code</b-col>
                    <b-col class="answer">{{account.sortCode}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Payment confirmation email id</b-col>
                    <b-col class="answer">{{account.paymentRefMailId}}</b-col>
                  </b-row>
                </b-col>
              </b-row>
            </span>
          </div>
        </b-col>
        <b-col class="border-right-color col-12 col-md-6">
          <b-row v-if="factoryDetails.length>0">
            <b-col class="border-bottom-color font-bold">Bank Details</b-col>
          </b-row>
          <div class="bankScroll" v-if="factoryDetails.length>0">
            <span v-for="(account,i) in bankAccounts" :key="i">
              <b-row>
                <b-col>
                  <b-row>
                    <b-col class="inner-title">Bank Account Details-{{i+1}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Account type</b-col>
                    <b-col class="answer">{{account.accountType}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Account Number</b-col>
                    <b-col class="answer">{{account.accountNumber}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Payment Mode</b-col>
                    <b-col class="answer">{{account.paymentModeCode}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Payment in favour of</b-col>
                    <b-col class="answer">{{account.accountHolderName}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Bank Name</b-col>
                    <b-col class="answer">{{account.bankName}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Payment Mode</b-col>
                    <b-col class="answer">{{account.paymentMode}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>IFSC Code</b-col>
                    <b-col class="answer">{{account.ifscCodeOrMicr}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Swift Code</b-col>
                    <b-col class="answer">{{account.swiftBicCode}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Sort Code</b-col>
                    <b-col class="answer">{{account.sortCode}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>IBAN Number</b-col>
                    <b-col class="answer">{{account.ibanNumber}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Payment confirmation email id</b-col>
                    <b-col class="answer">{{account.paymentRefMailId}}</b-col>
                  </b-row>
                </b-col>
              </b-row>
            </span>
          </div>
          <b-row v-if="partnerdetail.country.toLowerCase() == 'india'">
            <b-col class="border-bottom-color font-bold">Credentials</b-col>
          </b-row>
          <h3
            class="m-0 p-0 pb-2"
            v-if="partnerdetail.country.toLowerCase() == 'india'"
          >Customer Details</h3>
          <div class="customerScroll" v-if="partnerdetail.country.toLowerCase() == 'india'">
            <span v-for="(major,i) in majorOrCustomers" :key="i">
              <b-row>
                <b-col>
                  <b-row>
                    <b-col class="inner-title">Major/Key Customers-{{i+1}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Customer Name</b-col>
                    <b-col class="answer">{{major.customerName}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Years in partnership</b-col>
                    <b-col class="answer">{{major.yearsInPartnership}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Approximate revenue %</b-col>
                    <b-col class="answer">{{major.approximateRevenuePercentage}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>References</b-col>
                    <b-col class="answer">{{major.references}}</b-col>
                  </b-row>
                </b-col>
              </b-row>
            </span>
          </div>
          <h3
            class="m-0 p-0 pb-2"
            v-if="partnerdetail.country.toLowerCase() == 'india'"
          >Project Details</h3>
          <div class="projectScroll" v-if="partnerdetail.country.toLowerCase() == 'india'">
            <span v-for="(p,i) in projectStatus" :key="i">
              <b-row>
                <b-col>
                  <b-row>
                    <b-col class="inner-title">Project Status-{{i+1}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Type</b-col>
                    <b-col class="answer">{{p.projectType}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Origin</b-col>
                    <b-col class="answer">{{p.origin}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Country</b-col>
                    <b-col class="answer">{{p.country}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Location</b-col>
                    <b-col class="answer">{{p.location}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Project</b-col>
                    <b-col class="answer">{{p.projectName}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Period</b-col>
                    <b-col class="answer">{{p.projectPeriod}}</b-col>
                  </b-row>
                  <!-- <b-row>
                    <b-col>Currency</b-col>
                    <b-col>{{p.currencyCode}}</b-col>
                  </b-row>-->
                  <b-row>
                    <b-col>Value(INR)</b-col>
                    <b-col class="answer">{{p.projectValue}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Key Feature</b-col>
                    <b-col class="answer">{{p.keyFeatures}}</b-col>
                  </b-row>

                  <b-row>
                    <b-col>Customer</b-col>
                    <b-col class="answer">{{p.customerName}}</b-col>
                  </b-row>
                </b-col>
              </b-row>
            </span>
          </div>
          <b-row v-if="!branchLogIn">
            <b-col v-if="branchDetails.length > 0" class="border-bottom-color font-bold">Branch</b-col>
          </b-row>
          <div class="branchScroll" v-if="!branchLogIn">
            <span v-for="(data,i) in branchDetails" :key="i">
              <b-row>
                <b-col>
                  <b-row>
                    <b-col class="inner-title">Branch Details-{{i+1}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <span class="inner-title">Branch Name</span>
                      <span class="ml-2">-</span>
                      <span class="answer ml-2">{{data.name}}</span>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col class="inner-title">Address</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Street Address</b-col>
                    <b-col class="answer">{{data.address.streetAddress}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>City</b-col>
                    <b-col class="answer">{{data.address.city}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>State</b-col>
                    <b-col class="answer">{{data.address.state}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Country</b-col>
                    <b-col class="answer">{{data.address.country}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Pincode</b-col>
                    <b-col class="answer">{{data.address.postalCode}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col class="inner-title">Contact</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Person Name</b-col>
                    <b-col class="answer">{{data.contact.name}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Designation</b-col>
                    <b-col class="answer">{{data.contact.designation}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Country</b-col>
                    <b-col class="answer">{{data.contact.country}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Mobile</b-col>
                    <b-col class="answer">+{{data.contact.isdCode}}-{{data.contact.mobile}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>E-mail</b-col>
                    <b-col class="answer">{{data.contact.email}}</b-col>
                  </b-row>
                </b-col>
              </b-row>
            </span>
          </div>
          <b-row>
            <b-col class="border-bottom-color font-bold">Partnership Avenues</b-col>
          </b-row>
          <b-row>
            <b-col
              class="inner-title"
            >Have You Been Or Are You A Partner With Any Other Divsion Of L&T?</b-col>
          </b-row>
          <div class="othersScroll">
            <span v-for="(data,i) in othersResponse1" :key="i">
              <b-row>
                <b-col>
                  <b-row>
                    <b-col class="inner-title">Other Divsion-{{i+1}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Response</b-col>
                    <b-col class="answer">
                      <span v-if="data.response == 'N'">No</span>
                      <span v-if="data.response == 'Y'">Yes</span>
                    </b-col>
                  </b-row>
                  <b-row v-if="data.response == 'Y'">
                    <b-col>OD Details</b-col>
                    <b-col class="answer">{{data.odDetails}}</b-col>
                  </b-row>
                  <b-row v-if="data.response == 'Y'">
                    <b-col>Vendor Code</b-col>
                    <b-col class="answer">{{data.vendorCode}}</b-col>
                  </b-row>
                  <b-row v-if="data.response == 'Y'">
                    <b-col>Reason</b-col>
                    <b-col class="answer">{{data.reason}}</b-col>
                  </b-row>
                </b-col>
              </b-row>
            </span>
          </div>
          <b-row v-if="!branchLogIn">
            <b-col
              class="inner-title"
            >Is There Any L&T Employee Related To Senior Management In Your Organisation?</b-col>
          </b-row>
          <b-row v-if="employeeDetails.response == 'N' && !branchLogIn">
            <b-col>Response</b-col>
            <b-col class="answer">
              <span>No</span>
            </b-col>
          </b-row>
          <span v-if="employeeDetails.response == 'Y' && !branchLogIn">
            <b-row>
              <b-col>Name</b-col>
              <b-col class="answer">
                <span>{{employeeDetails.contactName}}</span>
              </b-col>
            </b-row>
            <b-row>
              <b-col>Designation</b-col>
              <b-col class="answer">
                <span>{{employeeDetails.designation}}</span>
              </b-col>
            </b-row>
            <b-row>
              <b-col>Mobile Number</b-col>
              <b-col class="answer">
                <span>+{{partnerdetail.isdCode}}-{{employeeDetails.mobileNumber}}</span>
              </b-col>
            </b-row>

            <b-row>
              <b-col>Email</b-col>
              <b-col class="answer">
                <span>{{employeeDetails.email}}</span>
              </b-col>
            </b-row>
          </span>
          <b-row>
            <b-col class="inner-title">Are you a related party with any division/unit/JV of L&T?</b-col>
          </b-row>
          <b-row v-if="relatedPartyTransaction.length == 0">
            <b-col>Response</b-col>
            <b-col class="answer">
              <span>No</span>
            </b-col>
          </b-row>
          <span v-if="relatedPartyTransaction.length > 0">
            <b-row>
              <b-col>Name</b-col>
              <b-col class="answer">
                <span>{{relatedPartyTransaction[0].name}}</span>
              </b-col>
            </b-row>
            <b-row>
              <b-col>Designation</b-col>
              <b-col class="answer">
                <span>{{relatedPartyTransaction[0].designation}}</span>
              </b-col>
            </b-row>
            <b-row>
              <b-col>Mobile Number</b-col>
              <b-col class="answer">
                <span>+{{partnerdetail.isdCode}}-{{relatedPartyTransaction[0].mobileNumber}}</span>
              </b-col>
            </b-row>

            <b-row>
              <b-col>Email</b-col>
              <b-col class="answer">
                <span>{{relatedPartyTransaction[0].email}}</span>
              </b-col>
            </b-row>
            <b-row>
              <b-col>Is pan applicable</b-col>
              <b-col class="answer">
                <span>{{relatedPartyTransaction[0].isPanApplicable == 'Y' ? 'Yes' : 'No' }}</span>
              </b-col>
            </b-row>
            <b-row v-if="relatedPartyTransaction[0].isPanApplicable == 'Y'">
              <b-col>PAN number</b-col>
              <b-col class="answer">
                <span>{{relatedPartyTransaction[0].panNumber}}</span>
              </b-col>
            </b-row>
          </span>
          <b-row>
            <b-col
              class="inner-title"
            >Are you related to L&T or its employees in any manner related to renting/leasing activity?</b-col>
          </b-row>
          <b-row v-if="propertyLeaseRental == null">
            <b-col>Response</b-col>
            <b-col class="answer">
              <span>No</span>
            </b-col>
          </b-row>
          <span v-if="propertyLeaseRental != null">
            <b-row v-if="propertyLeaseRental.name != null">
              <b-col>Response</b-col>
              <b-col class="answer">
                <span>Yes</span>
              </b-col>
            </b-row>
            <b-row v-if="propertyLeaseRental.name == null">
              <b-col>Response</b-col>
              <b-col class="answer">
                <span>No</span>
              </b-col>
            </b-row>
            <b-row v-if="propertyLeaseRental.isEmployee">
              <b-col>Is Employee of L&T</b-col>
              <b-col class="answer">
                <span>{{propertyLeaseRental.isEmployee == 'Y'?'Yes':'No'}}</span>
              </b-col>
            </b-row>
            <b-row v-if="propertyLeaseRental.employeeRelation">
              <b-col>Employee Relation</b-col>
              <b-col class="answer">
                <span>{{propertyLeaseRental.employeeRelation}}</span>
              </b-col>
            </b-row>
            <b-row v-if="propertyLeaseRental.name">
              <b-col>Name</b-col>
              <b-col class="answer">
                <span>{{propertyLeaseRental.name}}</span>
              </b-col>
            </b-row>
            <b-row v-if="propertyLeaseRental.psno">
              <b-col>Ps no</b-col>
              <b-col class="answer">
                <span>{{propertyLeaseRental.psno}}</span>
              </b-col>
            </b-row>

            <b-row v-if="propertyLeaseRental.isEngagedInPast">
              <b-col>Have you previously engaged with the company in renting/leasing activity?</b-col>
              <b-col class="answer">
                <span>{{propertyLeaseRental.isEngagedInPast == 'Y' ? 'Yes':'No'}}</span>
              </b-col>
            </b-row>
          </span>
          <h3 class="m-0 p-0 pb-2">Bussiness Vertical</h3>
          <div class="bussinessScroll">
            <span v-for="(other,i) in other3" :key="i">
              <b-row>
                <b-col>
                  <b-row>
                    <b-col class="inner-title">Business Verticals in Region You Can Partner-{{i+1}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Business type</b-col>
                    <b-col class="answer">{{other.businessType}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Business Vertical</b-col>
                    <b-col class="answer">{{other.businessVertical}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Region</b-col>
                    <b-col class="answer">{{other.region}}</b-col>
                  </b-row>
                </b-col>
              </b-row>
            </span>
          </div>
          <h3 v-if="referenceDetails.length > 0" class="m-0 p-0 pb-2">Refered By</h3>
          <span v-if="referenceDetails.length > 0">
            <b-row>
              <b-col>Type of Reference</b-col>
              <b-col class="answer">
                <span>{{referenceDetails[0].miscDetail}}</span>
              </b-col>
            </b-row>
            <b-row>
              <b-col>Name</b-col>
              <b-col class="answer">
                <span>{{referenceDetails[0].referredName}}</span>
              </b-col>
            </b-row>

            <span v-if="refferedbyBlock == false">
              <b-row v-if="refferedbyBlockName  == false">
                <b-col>CompanyName</b-col>
                <b-col class="answer">
                  <span>{{referenceDetails[0].referredCompanyName}}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col>Designation</b-col>
                <b-col class="answer">
                  <span>{{referenceDetails[0].designation}}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col>Mobile Number</b-col>
                <b-col class="answer">
                  <span>+{{partnerdetail.isdCode}}-{{referenceDetails[0].mobileNumber}}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col>Email</b-col>
                <b-col class="answer">
                  <span>{{referenceDetails[0].email}}</span>
                </b-col>
              </b-row>
            </span>
          </span>
          <!-- <b-row>
            <b-col class="border-bottom-color font-bold">Contact Details</b-col>
          </b-row>
          <div class="contactScroll">
            <span v-for="(contact,i) in contactDetails" :key="i">
              <b-row>
                <b-col>
                  <b-row>
                    <b-col class="inner-title" v-if="contact== 'P'">Prmary Contact</b-col>
                    <b-col class="inner-title" v-if="contact== 'S'">Secondary Contact</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Name</b-col>
                    <b-col class="answer">{{contact.contactName}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Designation</b-col>
                    <b-col class="answer">{{contact.designation}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Department</b-col>
                    <b-col class="answer">{{contact.region}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Mobile Number</b-col>
                    <b-col class="answer">{{contact.mobileNumber}}</b-col>
                  </b-row>
                  <b-row>
                    <b-col>Email-Id</b-col>
                    <b-col class="answer">{{contact.email}}</b-col>
                  </b-row>
                </b-col>
              </b-row>
            </span>
          </div>-->
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import DropDown from "../../widgets/DropDown";
import TextInput from "../../widgets/TextInput";
import multiSelect from "vue-multi-select";
import Radio from "../../widgets/RadioInput";
import FileUploader from "../../widgets/FileUploader.vue";
import moment from "moment";
import { SummaryServices } from "../../services/summaryService";
import partnerApprovalVue from "../../pages/partnerApproval.vue";
import { OnBoardingServices } from "../../services/onBoardingService";
const SummaryService = new SummaryServices();
const OnBoardingService = new OnBoardingServices();
export default {
  props: [
    "answerkey",
    "userid",
    "auditno",
    "branchLogIn",
    "partnerdetail",
    "vmCategoryCode",
    "vmCompanyCode",
    "vmModuleCode",
    "vmPartnerId"
  ],
  components: {
    "w-dropdown": DropDown,
    "w-text-input": TextInput,
    "w-radio": Radio,
    FileUploader,
    multiSelect
  },
  created() {
    this.getGeneralDetails();
  },

  data() {
    return {
      module: "general",
      refferedbyBlock: Boolean,
      refferedbyBlockName: Boolean,
      user: "mahi",
      organisationName: "",
      associateWithLnTAsA: "",
      pan: "",
      coOrdinatePerson: "",
      designation: "",
      email: "",
      mobileNumber: "",
      city: "",
      country: "",
      state: "",
      zipCode: "",
      streetAddress: "",
      regCity: "",
      regCountry: "",
      regState: "",
      regStreetAddress: "",
      regZipCode: "",
      esiRegionalOffice: "",
      esiRegistrationId: "",
      factoryInspectorsCertificateNumber: "",
      gstNumber: "",
      gstDocument: "",
      tanNumber: "",
      tanDocument: "",
      vatNumber: "",
      vatDocument: "",
      aadhaarNumber: "",
      aadhaarDocument: "",
      isEinvoiceApplicable: "",
      isTCSApplicable: "",
      incorporatedAs: "",
      msmeNumber: "",
      msmeType: "",
      pfRegionalOffice: "",
      pfRegistrationId: "",
      placeOfIncorporation: "",
      statutoryDetails: null,
      shopEstablishmentCertificateNumber: "",
      yearOfCommencementOfManufacturing: "",
      yearOfIncorporation: "",
      bankAccounts: [],
      majorOrCustomers: [],
      projectStatus: [],
      contactDetails: [],
      othersResponse1: [],
      branchDetails: [],
      factoryDetails: [],
      wareHouseDetail: [],
      referenceDetails: [],
      relatedPartyTransaction: [],
      propertyLeaseRental: {},
      employeeDetails: "",
      other3: [],
      userName: "",
      actionType: "",
      pfCount: null,
      esiRemarks: null,
      cinNumber: null,
      llpinNumber: null,
      frnNumber: null,
      sernNumber: null,
      isMsme: null
    };
  },

  methods: {
    getGeneralDetails() {
      if (this.$router.currentRoute.name == "OnboardingPreview") {
        // ForOnboardPreview
        OnBoardingService.getContent(this.module, this.answerkey).then(res => {
          if (res.status == "SUCCESS") {
            let resp = res.response.summary;
            this.populateFields(resp);
          }
        });
      } else if (this.$router.currentRoute.name == "VendorDetails") {
        // ForOnboardPreview
        var data = {
          categoryCode: this.vmCategoryCode,
          companyCode: this.vmCompanyCode,
          moduleCode: this.vmModuleCode,
          partnerId: this.vmPartnerId
        };
        SummaryService.getContentAdmin(data).then(res => {
          if (res.status == "SUCCESS") {
            let resp = res.response.summary;
            this.populateFields(resp);
          } else {
            window.alert(
              res.failureMessage + " for module code" + this.vmModuleCode
            );
          }
        });
      } else {
        // ForSummary
        SummaryService.getContent(
          this.module,
          this.answerkey,
          this.userid,
          this.auditno
        )
          .then(res => {
            if (res.status == "SUCCESS") {
              let resp = res.response.summary;
              this.populateFields(resp);
            }
          })
          .catch(err => {
            //sessionStorage.clear();
            // alert("SESSION EXPIRED");
            //  location.replace(process.env.VUE_APP_SUMMARYREDIRECT_URL);
          });
      }
    },
    document(attachment) {
      return attachment.split(/_(.+)/)[1];
    },
    showAttachFile(event) {
      this.loading = true;
      SummaryService.downLoadDocument(event).then(res => {
        this.loading = false;
      });
    },
    populateFields(res) {
      let organisationDetails;
      let contactDetailsResponse;
      let correspondenceAddress;
      let registeredOfficeAddress;
      let statutoryInformation;
      let bankDetails;
      let partnerShipAvenues;
      let others;

      this.bankAccounts = [];
      this.majorOrCustomers = [];
      this.projectStatus = [];
      this.other3 = [];
      this.relatedPartyTransaction = [];
      (this.propertyLeaseRental = {}), (this.othersResponse1 = []);
      this.branchDetails = [];

      organisationDetails = res.organisationDetails;
      this.organisationName = organisationDetails.nameOfTheOrganisation;
      this.associateWithLnTAsA = organisationDetails.associateWithLnTAsA;
      this.pan = organisationDetails.pan;
      this.contactDetails = organisationDetails.partnerBusinessContact;
      this.branchDetails = organisationDetails.branch;
      contactDetailsResponse = organisationDetails.contactDetailsResponse;
      this.coOrdinatePerson = contactDetailsResponse.coOrdinatePerson;
      this.designation = contactDetailsResponse.designation;
      this.email = contactDetailsResponse.email;
      this.mobileNumber = contactDetailsResponse.mobileNumber;

      correspondenceAddress = organisationDetails.correspondenceAddress;
      this.city = correspondenceAddress.city;
      this.country = correspondenceAddress.country;
      this.state = correspondenceAddress.state;
      this.streetAddress = correspondenceAddress.streetAddress;
      this.zipCode = correspondenceAddress.zipCode;

      registeredOfficeAddress = organisationDetails.registeredOfficeAddress;
      this.regCity = registeredOfficeAddress.city;
      this.regCountry = registeredOfficeAddress.country;
      this.regState = registeredOfficeAddress.state;
      this.regStreetAddress = registeredOfficeAddress.streetAddress;
      this.regZipCode = registeredOfficeAddress.zipCode;

      statutoryInformation = organisationDetails.statutoryInformation;
      this.esiRegionalOffice = statutoryInformation.esiRegionalOffice;
      this.pfCount = statutoryInformation.pfEmployeeCount;
      this.esiRemarks = statutoryInformation.esiRemarks;
      this.esiRegistrationId = statutoryInformation.esiRegistrationId;
      if (statutoryInformation.factoryInspectorsCertificateNumber != null) {
        this.factoryInspectorsCertificateNumber =
          statutoryInformation.factoryInspectorsCertificateNumber;
      } else {
        this.factoryInspectorsCertificateNumber = "-";
      }

      this.cinNumber = statutoryInformation.cinNumber;
      this.llpinNumber = statutoryInformation.llpinNumber;
      this.frnNumber = statutoryInformation.frnNumber;
      this.sernNumber = statutoryInformation.sernNumber;
      this.isMsme = statutoryInformation.isMsme;
      this.gstNumber = statutoryInformation.gstNumber;
      this.gstDocument = statutoryInformation.gstinDocumentId;
      this.tanNumber = statutoryInformation.tanNumber;
      this.tanDocument = statutoryInformation.tanDocumentId;
      this.vatNumber = statutoryInformation.vatNumber;
      this.vatDocument = statutoryInformation.vatDocumentId;
      this.aadhaarNumber = statutoryInformation.aadhaarNumber;
      this.aadhaarDocument = statutoryInformation.aadhaarDocumentId;
      this.incorporatedAs = statutoryInformation.incorporatedAs;
      this.isEinvoiceApplicable = statutoryInformation.isEinvoiceApplicable;
      this.isTCSApplicable = statutoryInformation.isTCSApplicable;
      this.msmeNumber = statutoryInformation.msmeNumber;
      this.msmeType = statutoryInformation.msmeType;
      this.statutoryDetails = statutoryInformation;
      this.pfRegionalOffice = statutoryInformation.pfRegionalOffice;
      this.pfRegistrationId = statutoryInformation.pfRegistrationId;
      this.placeOfIncorporation = statutoryInformation.placeOfIncorporation;
      if (statutoryInformation.shopEstablishmentCertificateNumber != null) {
        this.shopEstablishmentCertificateNumber =
          statutoryInformation.shopEstablishmentCertificateNumber;
      } else {
        this.shopEstablishmentCertificateNumber = "-";
      }
      if (statutoryInformation.yearOfIncorporation != null) {
        this.yearOfCommencementOfManufacturing =
          statutoryInformation.yearOfCommencementOfManufacturing;
      } else {
        this.yearOfCommencementOfManufacturing = "-";
      }
      this.yearOfIncorporation = statutoryInformation.yearOfIncorporation;

      this.factoryDetails = organisationDetails.factoryDetail;

      this.wareHouseDetail = organisationDetails.wareHouse;

      bankDetails = res.bankDetails;
      this.bankAccounts = bankDetails.accounts;

      partnerShipAvenues = res.partnerShipAvenues;
      this.majorOrCustomers = partnerShipAvenues.majorOrKeyCustomers;
      this.projectStatus = partnerShipAvenues.projectStatus;

      let other1;
      let other2;
      others = res.others;
      this.othersResponse1 = others.other1;
      this.employeeDetails = others.other2;
      this.other3 = others.other3;
      this.referenceDetails = others.reference;
      this.relatedPartyTransaction = others.relatedPartyResponse;
      this.propertyLeaseRental = others.propertyLeaseRentals;
      //alert(this.referenceDetails[0].miscDetail);
      if (
        this.referenceDetails[0].miscDetail == "Through Website" ||
        this.referenceDetails[0].miscDetail == "Social Media" ||
        this.referenceDetails[0].miscDetail == "Others"
      ) {
        this.refferedbyBlock = true;
      } else {
        this.refferedbyBlock = false;
      }
      if (this.referenceDetails[0].miscDetail == "L&T Employee") {
        this.refferedbyBlockName = true;
      } else {
        this.refferedbyBlockName = false;
      }
    }
  }
};
</script>


<style scoped>
.v-stepper__label {
  cursor: pointer;
}

.percentage {
  font-size: 30px;
  font-weight: 600;
  color: #002d72;
}
.percentageText {
  font-size: 20px;
  color: #002d72;
}
.card-img {
  height: 90px;
  margin: auto;
}
.groupcard {
  width: 90%;
  height: auto;
  padding: 40px;
  margin: 0 auto;
}
.cardText {
  margin-left: 10%;
  margin-right: 10%;
}
.cardDetails {
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 0.2px;
  color: #272727;
}
.selectedbox {
  border-radius: 6px;
  box-shadow: 0 2px 8px 0 rgba(0, 45, 114, 0.3);
  border: solid 3px #002d72;
}
.textValue {
  font-size: 16px;
  font-weight: 550;
  color: #333333;
  padding-left: 2%;
}
.financeText {
  font-size: 16px;
  font-weight: 550;
  color: #071b31;
  margin: 0;
  padding-left: 5%;
}
.addAccount {
  font-size: 18px;
  font-weight: 600;
  color: #003a78;
  padding-left: 5%;
}

.border-right-color {
  border-right: 1px solid #bababa;
}

.border-bottom-color {
  border-bottom: 1px solid #bababa;
  margin-left: 2.5%;
  margin-right: 2.5%;
  padding-left: 0%;
  margin-bottom: 1.5%;
}
.factory-border-bottom-color {
  border-bottom: 1px solid #bababa;
  font-size: 16px !important;
  margin-left: 2.5%;
  margin-right: 2.5%;
  padding-left: 0%;
  margin-bottom: 1.5%;
}

.font-bold {
  /* font-family: "Titillium Web", sans-serif; */
  font-family: "Source Sans Pro", sans-serif;
  font-weight: bold;
  font-size: 18px;
}

.generalRow {
  text-align: left;
}

.inner-title {
  /* font-family: "Titillium Web", sans-serif; */
  font-family: "Source Sans Pro", sans-serif;
  font-weight: bold;
  font-size: 13px;
}

/* .wrapper { */
/* font-family: "Titillium Web", sans-serif; */
/* font-family: "Source Sans Pro", sans-serif;
  font-size: 15px; */
/* } */

.col {
  /* line-height: 1.5; */
  padding-bottom: 1%;
  letter-spacing: 0.16px;
}

.answer {
  color: #6f6f6f;
}
h3 {
  font-weight: bold;
  font-size: 17px;
}
.bussinessScroll {
  max-height: 12vh;
  margin: 0;
  padding: 0;
  overflow-y: scroll;
  overflow-x: hidden;
}
.generalScroll {
  max-height: 107vh;
  margin: 0;
  padding: 0;
  overflow-y: scroll;
  overflow-x: hidden;
}
.othersScroll {
  max-height: 17vh;
  margin: 0;
  padding: 0;
  overflow-y: scroll;
  overflow-x: hidden;
}
.branchScroll {
  max-height: 42vh;
  margin: 0;
  padding: 0;
  overflow-y: scroll;
  overflow-x: hidden;
}
.projectScroll {
  max-height: 36vh;
  margin: 0;
  padding: 0;
  overflow-y: scroll;
  overflow-x: hidden;
}
.customerScroll {
  max-height: 17vh;
  margin: 0;
  padding: 0;
  overflow-y: scroll;
  overflow-x: hidden;
}
.bankScroll {
  max-height: 20vh;
  margin: 0;
  padding: 0;
  overflow-y: scroll;
  overflow-x: hidden;
}
.contactScroll {
  max-height: 20vh;
  margin: 0;
  padding: 0;
  overflow-y: scroll;
  overflow-x: hidden;
}
.factoryScroll {
  max-height: 30vh;
  margin: 0;
  padding: 0;
  overflow-y: scroll;
  overflow-x: hidden;
}
.modal-content {
  margin: auto;
}
.modal-dialog {
  max-width: 100% !important;
}
</style>